const productImageContext = require.context('../images/products', false, /\.(png|jpe?g|webp)$/);

const getProductImage = (fileName) => productImageContext(`./${fileName}`);

export const productCatalog = [
  {
    slug: 'kiosk',
    label: 'Kiosk',
    images: [
      getProductImage('kiosk.png'),
      getProductImage('kiosk01.png'),
      getProductImage('kiosk02.png'),
      getProductImage('kiosk03.png'),
      getProductImage('kiosk4.webp')
    ],
    shortDescription: 'Self-service interactive hardware terminals for various applications.',
    overview: 'Our Kiosk hardware solutions provide interactive self-service terminals for information display, ticketing, payment processing, and customer interaction. These robust hardware units are designed for high-traffic environments and 24/7 operation.',
    features: [
      'Touchscreen interface with responsive display',
      'Secure payment processing capabilities',
      'Customizable hardware configurations',
      'Durable construction for high-traffic areas',
      'Network connectivity options including Wi-Fi and Ethernet',
      'Anti-vandalism design'
    ],
    benefits: [
      'Reduces operational costs by automating services',
      'Improves customer experience with 24/7 availability',
      'Increases efficiency of service delivery',
      'Reduces staff workload for routine tasks'
    ],
    specifications: [
      { label: 'Display', value: '21.5 inch to 32 inch industrial-grade Full HD LED touchscreen' },
      { label: 'Touch Type', value: '10-point capacitive multi-touch' },
      { label: 'Processor', value: 'Intel Core i3 / i5 or industrial-grade ARM controller' },
      { label: 'Memory & Storage', value: '8 GB RAM, 256 GB SSD or higher' },
      { label: 'Operating System', value: 'Windows or Android' },
      { label: 'RFID Support', value: 'Integrated HF RFID, 13.56 MHz' },
      { label: 'Connectivity', value: 'LAN, Wi-Fi, USB, Bluetooth, optional 4G/5G' },
      { label: 'Warranty', value: '1 year standard, extendable up to 3 years' }
    ]
  },
  {
    slug: 'book-drop-box',
    label: 'Book Drop Box',
    images: [
      getProductImage('bookdropbox.png'),
      getProductImage('bookdropbox1.png'),
      getProductImage('bookdropbox2.png')
    ],
    shortDescription: 'Automated return system for library books with RFID technology.',
    overview: 'Our Book Drop Box hardware solution provides an automated system for library patrons to return books outside of operating hours. The system uses RFID technology to identify and process returned items efficiently.',
    features: [
      'RFID-based book identification and tracking',
      'Weather-resistant outdoor design',
      'Automated inventory management',
      'Real-time return notifications',
      'Secure storage with access control',
      'Integration with library management systems'
    ],
    benefits: [
      'Extends library return hours beyond operating time',
      'Reduces manual work for library staff',
      'Improves patron convenience',
      'Ensures accurate return tracking'
    ],
    specifications: [
      { label: 'RFID Frequency', value: '13.56 MHz HF RFID' },
      { label: 'Reader', value: 'Integrated RFID reader with multi-tag detection antenna' },
      { label: 'Detection Capability', value: 'Supports multiple book returns simultaneously' },
      { label: 'Capacity', value: 'Customizable high-capacity book bin with overflow protection' },
      { label: 'Software Integration', value: 'Library Management System with SIP2 or API integration' },
      { label: 'Connectivity', value: 'LAN, Wi-Fi, optional 4G' },
      { label: 'Installation', value: 'Indoor or semi-outdoor installation' },
      { label: 'Warranty', value: '1 year standard, extendable up to 3 years' }
    ]
  },
  {
    slug: 'rfid-library-security-gate',
    label: 'RFID Library Security Gate',
    images: [
      getProductImage('rfid-security-gate.png'),
      getProductImage('RFID security gate.png'),
      getProductImage('RFID security gate1.png'),
      getProductImage('RFID security gate2.png'),
      getProductImage('RFID security gate3.png')
    ],
    shortDescription: 'Security system for libraries using RFID technology to prevent unauthorized removal of items.',
    overview: 'Our RFID Library Security Gates provide a sophisticated hardware solution for preventing unauthorized removal of library materials. The system detects RFID-tagged items and triggers appropriate alerts while allowing authorized materials to pass freely.',
    features: [
      'RFID tag detection technology',
      'High-sensitivity sensors for accurate detection',
      'Visual and audible alarm systems',
      'Integration with library management systems',
      'Low-profile design for seamless installation',
      'Tamper-resistant construction'
    ],
    benefits: [
      'Reduces theft of library materials',
      'Maintains smooth patron flow',
      'Provides detailed security logs',
      'Integrates with existing library systems'
    ],
    specifications: [
      { label: 'RFID Frequency', value: '13.56 MHz HF RFID' },
      { label: 'Standards', value: 'ISO 15693 / ISO 18000-3 compliant' },
      { label: 'Detection Width', value: 'Up to 90 to 100 cm per aisle' },
      { label: 'Detection Accuracy', value: 'Above 99% detection efficiency' },
      { label: 'Alarm', value: 'Audio and visual alerts with configurable sensitivity' },
      { label: 'Connectivity', value: 'Ethernet with central monitoring support' },
      { label: 'Installation', value: 'Single, dual, or multi-gate scalable installation' },
      { label: 'Warranty', value: '1 year standard, extendable up to 3 years' }
    ]
  },
  {
    slug: 'rfid-enabled-smart-almirah-system',
    label: 'RFID Enabled Smart Almirah System',
    images: [
      getProductImage('rfid-smart-almirah.jpeg'),
      getProductImage('rfid-smart-almirah.png'),
      getProductImage('rfid-smart-almirah1.png')
    ],
    shortDescription: 'RFID-based smart storage almirah for automated tracking, issue-return, and controlled access.',
    overview: 'Our RFID Enabled Smart Almirah System is an intelligent storage and circulation solution designed for libraries, institutions, offices, and controlled inventory environments. It combines RFID-based identification, secured compartmentalized storage, and real-time software integration to automate tracking and improve accountability.',
    features: [
      'Integrated RFID reader and shelf-level tracking support',
      'Compartmentalized smart storage with organized shelving',
      'Real-time issue-return and inventory visibility',
      'Software integration for audit trail and reporting',
      'Access control with authenticated user workflow',
      'Heavy-duty cabinet construction for institutional deployment'
    ],
    benefits: [
      'Improves control over books, files, and tagged assets',
      'Reduces manual inventory verification effort',
      'Provides traceable transaction history',
      'Enhances storage efficiency with smart monitoring'
    ],
    specifications: [
      { label: 'RFID Frequency', value: '13.56 MHz HF RFID' },
      { label: 'Storage Type', value: 'Multi-shelf modular smart almirah with organized compartments' },
      { label: 'Detection Capability', value: 'Simultaneous multi-item detection with anti-collision' },
      { label: 'Access Control', value: 'RFID card or biometric authentication, optional' },
      { label: 'Inventory Visibility', value: 'Real-time item availability and movement tracking' },
      { label: 'Software Integration', value: 'Library, inventory, and document management systems' },
      { label: 'Connectivity', value: 'LAN, Wi-Fi, optional cloud connectivity' },
      { label: 'Warranty', value: '1 year standard, extendable up to 3 years' }
    ]
  },
  {
    slug: 'e-secure-smart-shelf',
    label: 'E-Secure Smart Shelf (Library RFID Intelligent Shelf)',
    images: [getProductImage('e-secure-smart-shelf.jpeg')],
    shortDescription: 'RFID-enabled intelligent shelf for real-time library item monitoring and faster inventory control.',
    overview: 'Our E-Secure Smart Shelf is a library-focused RFID intelligent shelf solution that helps institutions monitor tagged books and learning resources directly at shelf level. It supports real-time visibility, improves item traceability, and simplifies shelf management.',
    features: [
      'RFID-enabled shelf-level detection and monitoring',
      'Real-time visibility of tagged books and materials',
      'Integrated display panel for status and interaction',
      'Smart cabinet-style storage with organized multi-shelf layout',
      'Software integration for inventory records and tracking logs',
      'Durable institutional-grade design'
    ],
    benefits: [
      'Improves shelf accuracy and resource traceability',
      'Reduces manual effort in locating and verifying items',
      'Supports faster audits and inventory reconciliation',
      'Enhances library automation and service efficiency'
    ],
    specifications: [
      { label: 'RFID Frequency', value: '13.56 MHz HF RFID' },
      { label: 'Storage Type', value: 'Multi-shelf modular smart shelf with illuminated compartments' },
      { label: 'Shelf Monitoring', value: 'Real-time shelf-level item detection with misplacement alerts' },
      { label: 'Accuracy', value: 'Above 99% item detection accuracy' },
      { label: 'Interface', value: 'Integrated touchscreen or display panel' },
      { label: 'Software Integration', value: 'Library Management System with SIP2 or API support' },
      { label: 'Connectivity', value: 'LAN, Wi-Fi, optional cloud connectivity' },
      { label: 'Warranty', value: '1 year standard, extendable up to 3 years' }
    ]
  },
  {
    slug: 'rfid-smart-card',
    label: 'RFID Smart Card',
    images: [
      getProductImage('rfid-smart-card.jpeg'),
      getProductImage('rfid-smart-card.png'),
      getProductImage('rfid-smart-card1.png'),
      getProductImage('rfid-smart-card2.png')
    ],
    shortDescription: 'Contactless RFID smart card for access control, identification, and institutional workflows.',
    overview: 'Our RFID Smart Card is a compact contactless credential designed for secure identification, authentication, and access-enabled workflows. It is well suited for campuses, libraries, offices, and other institutions that need reliable user verification.',
    features: [
      'Contactless RFID smart card design',
      'Fast read response for tap-and-go usage',
      'Suitable for access control and identification systems',
      'Printable card surface for branding or user details',
      'Durable PVC body for regular daily handling'
    ],
    benefits: [
      'Simplifies secure user identification',
      'Improves speed at access and service points',
      'Supports centralized credential-based workflows',
      'Easy to issue for staff, students, or members'
    ],
    specifications: [
      { label: 'Card Type', value: 'High-quality PVC smart card with embedded RFID inlay' },
      { label: 'RFID Frequency', value: '13.56 MHz HF RFID' },
      { label: 'Memory', value: 'UID or sector-based memory options' },
      { label: 'Usage', value: 'Library membership, access control, attendance, and identity management' },
      { label: 'Security', value: 'Encrypted UID and secure authentication support' },
      { label: 'Personalization', value: 'Printable surface for branding, photo ID, barcode, and numbering' },
      { label: 'Read Range', value: 'Up to 5 to 10 cm' },
      { label: 'Compatibility', value: 'Compatible with standard HF RFID readers and systems' }
    ]
  },
  {
    slug: 'rfid-tag',
    label: 'RFID Tag',
    images: [
      getProductImage('rfid-tag.jpeg'),
      getProductImage('rfid-tag.png'),
      getProductImage('rfid-tag1.png'),
      getProductImage('rfid-tag2.png')
    ],
    shortDescription: 'RFID tagging label for asset, document, and library item identification.',
    overview: 'Our RFID Tag is designed for automated identification and tracking of books, files, assets, and inventory items. The slim label-style format helps institutions embed traceability into daily operations while supporting quicker scanning and movement logging.',
    features: [
      'Thin label-style RFID tag format',
      'Supports fast non-contact item identification',
      'Suitable for books, files, assets, and inventory items',
      'Easy integration into library and tracking workflows',
      'Designed for scalable tagging of large item volumes'
    ],
    benefits: [
      'Improves item tracking accuracy',
      'Speeds up inventory verification processes',
      'Reduces manual data-entry dependency',
      'Helps maintain better asset visibility'
    ],
    specifications: [
      { label: 'Tag Type', value: 'Adhesive RFID label or inlay for books, files, and assets' },
      { label: 'RFID Frequency', value: 'HF 13.56 MHz and UHF 860 to 960 MHz options' },
      { label: 'Standards', value: 'ISO 15693 / ISO 14443 / EPC Gen2 depending on variant' },
      { label: 'Memory', value: '512 bit to 1 KB and EPC plus user memory options' },
      { label: 'Read Range', value: 'HF up to 10 to 30 cm, UHF up to 5 to 10 meters' },
      { label: 'Features', value: 'Anti-collision, multi-tag reading, and fast response time' },
      { label: 'Form Factor', value: 'Ultra-thin flexible label with strong adhesive backing' },
      { label: 'Usage', value: 'Library automation, file tracking, asset management, and inventory systems' }
    ]
  },
  {
    slug: 'uhf-rfid-flap-barrier',
    label: 'UHF RFID Flap Barrier',
    images: [
      getProductImage('uhf-rfid-flap-barrier.jpeg'),
      getProductImage('uhf-rfid-flap-barrier.png'),
      getProductImage('uhf-rfid-flap-barrier1.png'),
      getProductImage('uhf-rfid-flap-barrier2.png'),
      getProductImage('uhf-rfid-flap-barrier3.png')
    ],
    shortDescription: 'Automated UHF RFID flap barrier for secure pedestrian access control.',
    overview: 'Our UHF RFID Flap Barrier is an intelligent pedestrian access control solution that combines automated barrier movement with RFID-based authorization. It is designed for institutional, corporate, and high-footfall premises where secure and trackable entry management is required.',
    features: [
      'UHF RFID-based user authentication support',
      'Motorized flap barrier for automated lane control',
      'LED indicators for entry and passage status',
      'Suitable for controlled entry and exit environments',
      'Integration support with access management systems'
    ],
    benefits: [
      'Improves access discipline in high-traffic areas',
      'Enhances security with controlled pedestrian flow',
      'Supports faster authorized entry processing',
      'Reduces dependency on manual gate supervision'
    ],
    specifications: [
      { label: 'RFID Frequency', value: 'UHF RFID, 860 to 960 MHz' },
      { label: 'Protocol', value: 'EPC Gen2 / ISO 18000-6C compliant' },
      { label: 'Barrier Type', value: 'Motorized high-speed pedestrian flap barrier lane' },
      { label: 'Reading Range', value: 'Up to 3 to 8 meters' },
      { label: 'Safety Features', value: 'Anti-pinch, obstacle detection, and emergency opening' },
      { label: 'Construction', value: 'Heavy-duty stainless steel housing' },
      { label: 'Connectivity', value: 'LAN / TCP-IP with centralized control system' },
      { label: 'Warranty', value: '1 year standard, extendable' }
    ]
  },
  {
    slug: 'ip-camera',
    label: 'IP Camera',
    images: [
      getProductImage('ip-camera.png'),
      getProductImage('ip camera.png'),
      getProductImage('ip camera1.png'),
      getProductImage('ip camera2.png')
    ],
    shortDescription: 'High-definition network cameras for security and surveillance applications.',
    overview: 'Our IP Camera hardware solutions offer high-definition surveillance capabilities with network connectivity. These cameras provide clear video footage for security and monitoring applications with advanced features such as night vision and motion detection.',
    features: [
      'High-definition video resolution options',
      'Network connectivity with PoE and Wi-Fi variants',
      'Night vision and low-light capabilities',
      'Motion detection and alerts',
      'Weather-resistant outdoor models',
      'Remote monitoring and control'
    ],
    benefits: [
      'Provides clear and detailed video evidence',
      'Allows remote monitoring from anywhere',
      'Reduces security risks and theft',
      'Scales easily with additional cameras'
    ],
    specifications: [
      { label: 'Resolution', value: '2 MP to 8 MP Full HD / Ultra HD options' },
      { label: 'Lens', value: 'Fixed or varifocal lens with wide viewing angle' },
      { label: 'Night Vision', value: 'IR night vision up to 30 to 50 meters' },
      { label: 'Video Compression', value: 'H.265+ / H.265 / H.264' },
      { label: 'AI Features', value: 'Motion detection, human detection, intrusion alert' },
      { label: 'Protection', value: 'IP66 / IP67 weatherproof outdoor housing' },
      { label: 'Storage', value: 'NVR, cloud, and local SD card support' },
      { label: 'Warranty', value: '1 year standard, extendable' }
    ]
  },
  {
    slug: 'solar-camera-with-solar-panel',
    label: 'Solar Camera with Solar Panel',
    images: [
      getProductImage('solar-camera.png'),
      getProductImage('solar camera.png'),
      getProductImage('solarcamera1.png'),
      getProductImage('solarcamera2.png')
    ],
    shortDescription: 'Solar-powered IP cameras for remote and off-grid surveillance.',
    overview: 'Our Solar Camera systems combine high-definition IP cameras with solar power technology for sustainable surveillance in remote locations. These self-sufficient units operate independently of grid power for continuous monitoring.',
    features: [
      'Integrated solar panel for self-powering',
      'High-capacity battery storage system',
      'High-definition video recording',
      'Weather-resistant and vandal-proof design',
      'Remote monitoring capabilities'
    ],
    benefits: [
      'Operates independently of grid power',
      'Cost-effective for remote locations',
      'Environmentally friendly solution',
      'Reduced infrastructure costs'
    ],
    specifications: [
      { label: 'Camera Resolution', value: '2 MP to 5 MP Full HD / HD options' },
      { label: 'Solar Panel', value: 'High-efficiency mono-crystalline solar panel' },
      { label: 'Battery', value: 'High-capacity lithium battery with smart charge controller' },
      { label: 'Backup Time', value: '2 to 3 days autonomy without sunlight' },
      { label: 'Connectivity', value: '4G SIM-based remote access, optional Wi-Fi / LAN' },
      { label: 'Night Vision', value: 'IR night vision up to 30 to 50 meters' },
      { label: 'Protection', value: 'IP66 / IP67 weatherproof enclosure' },
      { label: 'Warranty', value: '1 year standard, extendable' }
    ]
  },
  {
    slug: 'biometric-device-face',
    label: 'Biometric Device (Face Recognition)',
    images: [getProductImage('biometric-face.png')],
    shortDescription: 'Advanced facial recognition hardware for secure access control and attendance.',
    overview: 'Our face recognition biometric devices use advanced AI algorithms to provide secure and accurate facial identification for access control, attendance tracking, and security applications. These high-performance units ensure reliable recognition in different lighting conditions.',
    features: [
      'Advanced facial recognition algorithms',
      'High-speed processing and identification',
      'Anti-spoofing technology',
      'Integration with access control systems',
      'Multiple connectivity options',
      'Tamper-resistant design'
    ],
    benefits: [
      'Provides contactless and hygienic identification',
      'Reduces fraud and unauthorized access',
      'Fast and accurate recognition',
      'Improves security and accountability'
    ],
    specifications: [
      { label: 'Display', value: '4 inch to 7 inch HD color touchscreen' },
      { label: 'Authentication', value: 'Face, RFID card, password, and optional QR support' },
      { label: 'Face Capacity', value: 'Up to 5,000 faces' },
      { label: 'Recognition Speed', value: 'Less than 1 second' },
      { label: 'Accuracy', value: 'Above 99% with anti-spoofing' },
      { label: 'Log Capacity', value: 'Up to 200,000 transaction records' },
      { label: 'Connectivity', value: 'TCP/IP, USB, Wi-Fi, optional cloud connectivity' },
      { label: 'Warranty', value: '1 year standard, extendable' }
    ]
  },
  {
    slug: 'biometric-device-fingerprint',
    label: 'Biometric Device (Fingerprint)',
    images: [getProductImage('biometric-fingerprint.png')],
    shortDescription: 'Precision fingerprint recognition hardware for secure authentication.',
    overview: 'Our fingerprint recognition biometric devices provide accurate and reliable fingerprint identification for access control, time tracking, and security applications. These devices use advanced sensor technology for high-accuracy recognition.',
    features: [
      'High-resolution fingerprint sensors',
      'Fast and accurate recognition algorithms',
      'Multiple fingerprint template storage',
      'Anti-spoofing capabilities',
      'Integration with management systems'
    ],
    benefits: [
      'Provides secure tamper-proof identification',
      'Reduces administrative overhead',
      'Eliminates buddy punching in attendance',
      'Cost-effective biometric solution'
    ],
    specifications: [
      { label: 'Sensor', value: 'High-precision optical or capacitive fingerprint sensor' },
      { label: 'Authentication', value: 'Fingerprint, RFID card, password, and PIN' },
      { label: 'Fingerprint Capacity', value: 'Up to 5,000 templates' },
      { label: 'Matching Speed', value: 'Less than 1 second' },
      { label: 'Accuracy', value: 'High accuracy with optimized FAR / FRR' },
      { label: 'Log Capacity', value: 'Up to 200,000 attendance records' },
      { label: 'Connectivity', value: 'TCP/IP, USB, Wi-Fi, and cloud integration support' },
      { label: 'Warranty', value: '1 year standard, extendable' }
    ]
  },
  {
    slug: 'gps-device',
    label: 'GPS Device',
    images: [
      getProductImage('gps-device.jpg'),
      getProductImage('gps.png'),
      getProductImage('gps1.png'),
      getProductImage('gps2.png'),
      getProductImage('gps3.png')
    ],
    shortDescription: 'Precision GPS tracking hardware for vehicle and asset monitoring.',
    overview: 'Our GPS tracking devices provide real-time location monitoring for vehicles, assets, and personnel. These compact, reliable units offer accurate positioning data with multiple connectivity options for continuous tracking.',
    features: [
      'High-precision GPS positioning',
      'Real-time location tracking',
      'Multiple connectivity options including GSM and 4G',
      'Geofencing and alert capabilities',
      'Compact and weather-resistant design'
    ],
    benefits: [
      'Provides real-time location visibility',
      'Reduces fuel costs and improves efficiency',
      'Enhances security of vehicles and assets',
      'Optimizes route planning and logistics'
    ],
    specifications: [
      { label: 'Positioning', value: 'GPS / GNSS based real-time tracking' },
      { label: 'Network', value: '2G / 4G SIM-based communication' },
      { label: 'Alerts', value: 'Ignition, overspeed, geofence, and power cut alerts' },
      { label: 'Inputs', value: 'Digital input and output support as per model' },
      { label: 'Battery', value: 'Internal backup battery' },
      { label: 'Software', value: 'Web and mobile tracking platform support' },
      { label: 'Installation', value: 'Vehicle wiring and dashboard configuration support' },
      { label: 'Warranty', value: '1 year standard warranty' }
    ]
  },
  {
    slug: 'smart-class-monitor',
    label: 'Smart Class Monitor',
    images: [
      getProductImage('smart-class-monitor.png'),
      getProductImage('smart class.png'),
      getProductImage('smart class1.png')
    ],
    shortDescription: 'Interactive display hardware for modern educational environments.',
    overview: 'Our Smart Class Monitors are large interactive displays designed for educational environments. These hardware solutions combine high-definition displays with touch capabilities for enhanced learning experiences.',
    features: [
      'Large high-definition interactive display',
      'Multi-touch capability for multiple users',
      'Integrated speakers and audio system',
      'Multiple input connectivity options',
      'Anti-glare screen technology'
    ],
    benefits: [
      'Enhances student engagement and interaction',
      'Supports multimedia learning content',
      'Improves classroom collaboration',
      'Supports modern teaching methodologies'
    ],
    specifications: [
      { label: 'Display Size', value: '65 inch / 75 inch / 86 inch industrial-grade panels' },
      { label: 'Resolution', value: '4K UHD, 3840 x 2160 anti-glare display' },
      { label: 'Touch', value: '20-point infrared or capacitive touch' },
      { label: 'Operating System', value: 'Android with optional Windows OPS module' },
      { label: 'RAM & Storage', value: '4 GB / 8 GB RAM with 32 GB / 64 GB storage' },
      { label: 'Connectivity', value: 'HDMI, USB, Type-C, LAN, Wi-Fi, Bluetooth, wireless screen sharing' },
      { label: 'Features', value: 'Whiteboard, annotation, screen recording, multi-device casting' },
      { label: 'Warranty', value: '1 year standard, extendable up to 3 years' }
    ]
  },
  {
    slug: 'issue-return-biometric',
    label: 'Issue Return (Biometric Registration)',
    images: [
      getProductImage('issue-return.png'),
      getProductImage('issuereturn.png'),
      getProductImage('issuereturn1.png')
    ],
    shortDescription: 'Library issue-return hardware system with biometric authentication.',
    overview: 'Our Issue Return system combines biometric authentication hardware with library management capabilities to streamline the process of issuing and returning books. The system ensures accurate tracking and reduces administrative overhead.',
    features: [
      'Integrated biometric authentication including face and fingerprint',
      'RFID-based book identification',
      'Real-time inventory updates',
      'User-friendly interface for librarians',
      'Secure transaction logging'
    ],
    benefits: [
      'Reduces manual book handling errors',
      'Improves security with biometric authentication',
      'Speeds up issuance and return processes',
      'Provides detailed transaction logs'
    ],
    specifications: [
      { label: 'Authentication', value: 'Face recognition, fingerprint, RFID card, and PIN support' },
      { label: 'RFID Frequency', value: '13.56 MHz HF RFID' },
      { label: 'Detection Capability', value: 'Multi-book issue or return with anti-collision support' },
      { label: 'Display', value: 'Industrial touchscreen interface' },
      { label: 'Processing Speed', value: 'Less than 2 seconds per operation' },
      { label: 'Printer', value: 'Integrated or optional thermal receipt printer' },
      { label: 'Software Integration', value: 'Library Management System with SIP2 or API support' },
      { label: 'Warranty', value: '1 year standard, extendable' }
    ]
  },
  {
    slug: 'staff-station-biometric',
    label: 'Staff Station (Biometric Registration)',
    images: [
      getProductImage('staff-station.png'),
      getProductImage('Staff station.png'),
      getProductImage('Staff station1.png'),
      getProductImage('Staff station2.png')
    ],
    shortDescription: 'Dedicated hardware station for staff biometric authentication and management.',
    overview: 'Our Staff Station hardware provides a dedicated system for staff biometric authentication, attendance tracking, and management tasks. It is designed for high-traffic office environments with robust construction.',
    features: [
      'High-capacity biometric processing',
      'Dedicated staff management interface',
      'Integration with HR systems',
      'High-traffic capability',
      'Multi-biometric support including face and fingerprint'
    ],
    benefits: [
      'Accurate staff attendance tracking',
      'Reduces administrative overhead',
      'Prevents buddy punching',
      'Integrates with payroll systems'
    ],
    specifications: [
      { label: 'Authentication', value: 'Face, fingerprint, RFID card, and password-based authentication' },
      { label: 'User Capacity', value: 'Scalable database supporting thousands of users' },
      { label: 'Display', value: 'Touchscreen or LCD interface for operator control' },
      { label: 'Processing Speed', value: 'Less than 1 second identification and verification' },
      { label: 'Data Management', value: 'Real-time attendance tracking with centralized dashboard' },
      { label: 'Data Export', value: 'Excel, CSV, and cloud-based reporting' },
      { label: 'Connectivity', value: 'LAN, Wi-Fi, USB, and cloud connectivity support' },
      { label: 'Warranty', value: '1 year standard, extendable' }
    ]
  },
  {
    slug: 'rfid-handle-device',
    label: 'RFID Handle Device',
    images: [
      getProductImage('rfid-handle-device.png'),
      getProductImage('rfid handle device.png'),
      getProductImage('rfid handle device1.png'),
      getProductImage('rfid handle device2.png'),
      getProductImage('rfid handle device3.png')
    ],
    shortDescription: 'Handheld RFID scanner for library and inventory management applications.',
    overview: 'Our RFID Handle Device is a portable hardware scanner designed for reading RFID tags in libraries and inventory environments. The ergonomic design allows comfortable extended use while maintaining accurate scanning performance.',
    features: [
      'Ergonomic handheld design',
      'High-sensitivity RFID scanning',
      'Long battery life for extended use',
      'Wireless connectivity options',
      'Durable construction for daily use'
    ],
    benefits: [
      'Improves inventory management efficiency',
      'Reduces manual scanning time',
      'Provides accurate RFID reading',
      'Portable for flexible use scenarios'
    ],
    specifications: [
      { label: 'RFID Frequency', value: 'HF 13.56 MHz and UHF 860 to 960 MHz supported models' },
      { label: 'Protocol', value: 'ISO 15693 / EPC Gen2 depending on model' },
      { label: 'Reading Range', value: 'HF up to 30 cm, UHF up to 10 to 15 meters' },
      { label: 'Read Speed', value: 'High-speed multi-tag reading' },
      { label: 'Display', value: 'Industrial handheld touchscreen with Android OS' },
      { label: 'Connectivity', value: 'Wi-Fi, Bluetooth, USB, optional 4G' },
      { label: 'Battery', value: 'Rechargeable battery with 6 to 10 hours backup' },
      { label: 'Warranty', value: '1 year standard, extendable' }
    ]
  },
  {
    slug: 'barcode-scanner',
    label: 'Barcode Scanner',
    images: [
      getProductImage('barcode-scanner.png'),
      getProductImage('barcode.png'),
      getProductImage('barcode1.png'),
      getProductImage('barcode2.png')
    ],
    shortDescription: 'High-performance hardware barcode scanners for retail and inventory applications.',
    overview: 'Our Barcode Scanners provide fast and accurate reading of various barcode formats. These durable hardware units are designed for high-volume scanning applications in retail, inventory, and logistics environments.',
    features: [
      'High-speed barcode reading',
      'Support for multiple barcode formats',
      'Durable construction for heavy use',
      'Multiple connectivity options',
      'Long-range scanning capability'
    ],
    benefits: [
      'Increases scanning speed and accuracy',
      'Reduces manual data entry errors',
      'Improves inventory management',
      'Integrates with existing systems'
    ],
    specifications: [
      { label: 'Scan Type', value: '1D / 2D barcode scanner, laser or imager based' },
      { label: 'Supported Codes', value: 'QR, Code 128, EAN, UPC, and standard barcode formats' },
      { label: 'Scan Speed', value: 'Fast scanning with instant decoding response' },
      { label: 'Connectivity', value: 'USB wired, Bluetooth wireless, and RF models available' },
      { label: 'Scan Mode', value: 'Manual trigger, continuous, and auto-sense modes' },
      { label: 'Build', value: 'Industrial-grade durable body with drop resistance' },
      { label: 'Compatibility', value: 'Compatible with Windows, Android, and common software systems' },
      { label: 'Warranty', value: '1 year standard, extendable' }
    ]
  },
  {
    slug: 'standy',
    label: 'Standy',
    images: [
      getProductImage('standy.png'),
      getProductImage('standy1.png'),
      getProductImage('standy2.png')
    ],
    shortDescription: 'Hardware stands and mounting solutions for various equipment and displays.',
    overview: 'Our Standy hardware solutions provide professional mounting and positioning systems for displays, cameras, kiosks, and other equipment. These stands offer stability, adjustability, and professional presentation.',
    features: [
      'Adjustable height and positioning',
      'Sturdy construction for heavy equipment',
      'Cable management solutions',
      'Quick-release mounting systems',
      'Customizable configurations'
    ],
    benefits: [
      'Provides stable equipment mounting',
      'Optimizes equipment positioning',
      'Manages cables for clean installation',
      'Professional appearance'
    ],
    specifications: [
      { label: 'Material', value: 'Powder-coated MS / SS industrial-grade structure' },
      { label: 'Compatibility', value: 'Supports kiosks, displays, cameras, biometric, and RFID devices' },
      { label: 'Height', value: 'Standard and customizable height options' },
      { label: 'Cable Management', value: 'Internal concealed cable routing system' },
      { label: 'Base', value: 'Heavy stable base with floor mounting and anti-vibration support' },
      { label: 'Finish', value: 'Premium powder-coated finish with custom color options' },
      { label: 'Installation', value: 'Indoor and outdoor weather-protected installation support' },
      { label: 'Warranty', value: '1 year standard, extendable' }
    ]
  },
  {
    slug: 'rommer-touch-screen',
    label: 'Rommer (Touch Screen Wall)',
    images: [
      getProductImage('rommer.png'),
      getProductImage('roombr.png'),
      getProductImage('roombr1.png'),
      getProductImage('roombr2.png')
    ],
    shortDescription: 'Hardware system to convert any wall into a large interactive touch screen.',
    overview: 'Our Rommer hardware system transforms any wall surface into an interactive touch screen display up to 100 inches in Full HD quality. This solution provides large-format interactive capability for presentations, education, and collaboration.',
    features: [
      'Converts any wall into a touch screen',
      'Up to 100-inch display capability',
      'Full HD quality output',
      'Multi-user touch capability',
      'Wireless connectivity options',
      'Easy installation with minimal setup'
    ],
    benefits: [
      'Provides large-format interactive display',
      'Cost-effective alternative to large screens',
      'Flexible installation on existing walls',
      'Supports collaborative work'
    ],
    specifications: [
      { label: 'Display Area', value: 'Up to 100 inch or larger interactive projection area' },
      { label: 'Resolution', value: 'Full HD or 4K output depending on projector' },
      { label: 'Touch Support', value: 'Multi-touch interactive surface with gesture support' },
      { label: 'Response Time', value: 'Low latency smooth touch interaction' },
      { label: 'Input', value: 'PC, laptop, Android, and external media sources' },
      { label: 'Connectivity', value: 'HDMI, USB, LAN, and wireless screen sharing' },
      { label: 'Features', value: 'Annotation, digital whiteboard, screen recording, collaboration tools' },
      { label: 'Warranty', value: '1 year standard, extendable' }
    ]
  },
  {
    slug: 'server-room-establishment',
    label: 'Server Room Establishment',
    images: [
      getProductImage('server-room.png'),
      getProductImage('server room.png'),
      getProductImage('server room1.png'),
      getProductImage('server room2.png')
    ],
    shortDescription: 'Complete hardware setup for Windows and Linux server room infrastructure.',
    overview: 'Our Server Room Establishment service includes complete hardware setup for Windows and Linux server environments. We provide all necessary hardware components for reliable, scalable server infrastructure.',
    features: [
      'Server hardware selection and configuration',
      'Rack mounting and organization systems',
      'Power management and UPS solutions',
      'Climate control and cooling systems',
      'Network infrastructure setup',
      'Security and access control systems'
    ],
    benefits: [
      'Professional server infrastructure setup',
      'Optimized performance and reliability',
      'Proper cooling and power management',
      'Scalable for future growth'
    ],
    specifications: [
      { label: 'Server Support', value: 'Windows and Linux server deployment' },
      { label: 'Rack', value: 'Wall mount and floor standing rack options' },
      { label: 'Power', value: 'UPS, power distribution, and earthing planning' },
      { label: 'Networking', value: 'Switching, routing, patch panel, and structured cabling' },
      { label: 'Cooling', value: 'Ventilation and AC planning as per heat load' },
      { label: 'Security', value: 'Access control, CCTV, and fire safety planning options' },
      { label: 'Documentation', value: 'Rack layout, cable labeling, and handover documentation' },
      { label: 'Warranty', value: 'Project warranty as per supplied hardware' }
    ]
  }
];

const productEnhancements = {
  kiosk: {
    useCases: ['Visitor self-service counters', 'Library access and issue-return desks', 'Campus help points', 'Payment and registration touchpoints'],
    integrations: ['RFID modules', 'Barcode scanners', 'Thermal printers', 'Access control or application software'],
    deployment: 'Delivered with hardware configuration, UI workflow alignment, peripheral mapping, installation, and commissioning support.',
    support: 'Includes deployment planning, operator handover, and warranty-backed support for institutional usage.',
    ctaTitle: 'Plan a Kiosk Deployment',
    ctaText: 'Discuss screen size, peripherals, software workflow, and site rollout with our team.'
  },
  'book-drop-box': {
    useCases: ['Academic libraries', 'Public libraries', 'Institutional learning centers', 'After-hours return stations'],
    integrations: ['Library Management System', 'RFID circulation workflow', 'Receipt printing', 'Transaction logging dashboard'],
    deployment: 'Configured around bin capacity, user flow, and LMS integration requirements with installation support.',
    support: 'Covers RFID tuning, return workflow setup, user guidance flow, and maintenance assistance.',
    ctaTitle: 'Set Up an Automated Return Point',
    ctaText: 'Get the right return capacity, integration flow, and site-fit configuration for your library.'
  },
  'rfid-library-security-gate': {
    useCases: ['Library exit control', 'Reference section protection', 'Multi-gate library halls', 'Institutional knowledge centers'],
    integrations: ['HF RFID tags', 'Library Management System', 'Event logging', 'Security monitoring workflows'],
    deployment: 'Deployment includes aisle planning, detection tuning, and monitoring configuration based on entry-exit volume.',
    support: 'Includes calibration, on-site setup, false alarm optimization, and post-installation assistance.',
    ctaTitle: 'Secure Your Library Exits',
    ctaText: 'Review aisle count, reader sensitivity, and control-point layout for your facility.'
  },
  'rfid-enabled-smart-almirah-system': {
    useCases: ['Secure document rooms', 'Library smart storage', 'Controlled institutional inventory', 'Research or departmental storage'],
    integrations: ['RFID authentication', 'Inventory systems', 'Document management workflows', 'Access control mechanisms'],
    deployment: 'Built around storage capacity, access model, and asset visibility requirements with site-specific planning.',
    support: 'Covers software mapping, access control alignment, reporting setup, and operational training.',
    ctaTitle: 'Design a Smart Storage Setup',
    ctaText: 'Match shelf capacity, access rules, and tracking visibility to your operational workflow.'
  },
  'e-secure-smart-shelf': {
    useCases: ['Smart library sections', 'High-value book collections', 'Resource visibility zones', 'Automated shelf monitoring'],
    integrations: ['Library Management System', 'RFID search and tracking', 'Shelf analytics', 'User assistance displays'],
    deployment: 'Configured around shelf layout, category flow, and real-time tracking requirements for modern libraries.',
    support: 'Includes shelf-level setup, visibility tuning, analytics enablement, and support after go-live.',
    ctaTitle: 'Modernize Shelf-Level Tracking',
    ctaText: 'Build a smart shelf experience that improves visibility, control, and user access.'
  },
  'rfid-smart-card': {
    useCases: ['Campus ID cards', 'Library membership cards', 'Office access credentials', 'Attendance-linked identity workflows'],
    integrations: ['HF RFID readers', 'Access control systems', 'Attendance software', 'Identity management workflows'],
    deployment: 'Delivered with card format planning, reader compatibility validation, and workflow alignment support.',
    support: 'Covers personalization planning, system compatibility checks, and deployment guidance.',
    ctaTitle: 'Deploy Secure RFID Credentials',
    ctaText: 'Align card format, reader compatibility, and institutional workflow before rollout.'
  },
  'rfid-tag': {
    useCases: ['Library item tagging', 'Asset tracking', 'File movement control', 'Inventory automation'],
    integrations: ['RFID readers', 'Library automation software', 'Inventory systems', 'Tracking dashboards'],
    deployment: 'Planned around tag volume, surface/application type, and read-range requirements.',
    support: 'Includes compatibility checks, tagging workflow guidance, and deployment planning support.',
    ctaTitle: 'Scale RFID Tagging',
    ctaText: 'Choose the right tag type and rollout model for books, files, or assets.'
  },
  'uhf-rfid-flap-barrier': {
    useCases: ['Corporate access lanes', 'Campus entry points', 'Institutional security checkpoints', 'Visitor flow control'],
    integrations: ['UHF RFID credentials', 'Biometric systems', 'Attendance software', 'Visitor management platforms'],
    deployment: 'Includes lane sizing, throughput planning, access rule mapping, and on-site commissioning.',
    support: 'Covers device integration, safety tuning, user flow validation, and maintenance support.',
    ctaTitle: 'Control High-Footfall Entry Points',
    ctaText: 'Plan a faster, safer, and better-controlled pedestrian access workflow.'
  },
  'ip-camera': {
    useCases: ['Campus surveillance', 'Office perimeter coverage', 'Library monitoring', 'Facility operations oversight'],
    integrations: ['NVR storage', 'Remote monitoring software', 'Network infrastructure', 'Alerting workflows'],
    deployment: 'Camera placement, coverage angle, recording strategy, and network planning are aligned before installation.',
    support: 'Includes installation planning, storage design, monitoring setup, and service assistance.',
    ctaTitle: 'Build a Smarter Surveillance Layout',
    ctaText: 'Map camera positions, coverage zones, and storage strategy to your security requirement.'
  },
  'solar-camera-with-solar-panel': {
    useCases: ['Remote surveillance points', 'Off-grid monitoring', 'Outdoor security poles', 'Infrastructure edge locations'],
    integrations: ['4G remote viewing', 'Cloud or NVR storage', 'Alert workflows', 'Power autonomy planning'],
    deployment: 'Designed around sunlight conditions, backup expectations, and remote monitoring requirements.',
    support: 'Covers site survey, power planning, mounting strategy, and operational support.',
    ctaTitle: 'Secure Remote Locations',
    ctaText: 'Assess solar feasibility, backup expectations, and remote connectivity before deployment.'
  },
  'biometric-device-face': {
    useCases: ['Attendance points', 'Door access control', 'Reception verification', 'Institutional identity checkpoints'],
    integrations: ['Attendance software', 'Access control panels', 'RFID cards', 'Cloud or LAN management'],
    deployment: 'Configured around user volume, access policy, and environment-specific placement requirements.',
    support: 'Includes enrollment planning, device setup, access rule mapping, and post-installation support.',
    ctaTitle: 'Deploy Contactless Verification',
    ctaText: 'Set up face-based attendance or access workflows with the right capacity and control model.'
  },
  'biometric-device-fingerprint': {
    useCases: ['Attendance terminals', 'Secure access points', 'Department verification desks', 'Shift-based workforce tracking'],
    integrations: ['Attendance software', 'Door lock systems', 'RFID credentials', 'Payroll or HR workflows'],
    deployment: 'Device placement, enrollment model, and user-volume handling are aligned during setup.',
    support: 'Covers device integration, enrollment assistance, reporting flow, and support services.',
    ctaTitle: 'Roll Out Fingerprint Authentication',
    ctaText: 'Choose the right capacity, authentication mode, and integration flow for your team.'
  },
  'gps-device': {
    useCases: ['Fleet monitoring', 'Asset tracking', 'Field movement visibility', 'Route and compliance oversight'],
    integrations: ['Tracking platforms', 'Alert workflows', 'Mobile dashboards', 'Reporting systems'],
    deployment: 'Planned around fleet type, reporting expectations, and alert configuration requirements.',
    support: 'Includes installation guidance, platform setup, geofence configuration, and service support.',
    ctaTitle: 'Track Vehicles and Assets Better',
    ctaText: 'Define the right monitoring, alerting, and reporting setup for your movement operations.'
  },
  'smart-class-monitor': {
    useCases: ['Digital classrooms', 'Training rooms', 'Seminar halls', 'Collaborative learning environments'],
    integrations: ['Casting tools', 'Video conferencing', 'OPS modules', 'Interactive presentation workflows'],
    deployment: 'Display size, room layout, connectivity, and teaching use-case are aligned during planning.',
    support: 'Includes installation, training, input setup, and post-deployment support.',
    ctaTitle: 'Upgrade Teaching and Collaboration',
    ctaText: 'Select the right screen size, operating setup, and classroom workflow for your space.'
  },
  'issue-return-biometric': {
    useCases: ['Library circulation desks', 'Self-service issue-return points', 'RFID-enabled library workflows', 'Controlled borrowing systems'],
    integrations: ['Library Management System', 'RFID books', 'Biometric authentication', 'Receipt printing'],
    deployment: 'Configured around circulation rules, authentication flow, and issue-return volume handling.',
    support: 'Covers integration setup, user flow tuning, device mapping, and support services.',
    ctaTitle: 'Automate Library Circulation',
    ctaText: 'Bring issue, return, authentication, and logging into one efficient circulation point.'
  },
  'staff-station-biometric': {
    useCases: ['Staff registration desks', 'HR attendance counters', 'Access control enrollment', 'Administrative verification points'],
    integrations: ['HR systems', 'Attendance software', 'Door control', 'Cloud or LAN data sync'],
    deployment: 'Set up based on user volume, registration workflow, and reporting requirements.',
    support: 'Includes operator training, workflow setup, integration support, and maintenance guidance.',
    ctaTitle: 'Centralize Staff Verification',
    ctaText: 'Align registration, attendance, and access workflows through a dedicated biometric station.'
  },
  'rfid-handle-device': {
    useCases: ['Stock verification', 'Shelf scanning', 'Asset search', 'Inventory audits'],
    integrations: ['Inventory systems', 'Library platforms', 'Wireless sync workflows', 'Audit reporting'],
    deployment: 'Planned around read range, use environment, and field mobility expectations.',
    support: 'Includes workflow guidance, software compatibility checks, and support for operational rollout.',
    ctaTitle: 'Speed Up RFID Audits',
    ctaText: 'Choose the right handheld workflow for inventory, shelf checks, and search operations.'
  },
  'barcode-scanner': {
    useCases: ['Retail counters', 'Inventory desks', 'Library transaction points', 'Logistics scanning workflows'],
    integrations: ['Billing software', 'Inventory systems', 'Library modules', 'Windows and Android devices'],
    deployment: 'Configured by scan volume, barcode type, and hardware connectivity preference.',
    support: 'Covers compatibility validation, setup guidance, and operational assistance.',
    ctaTitle: 'Improve Scanning Throughput',
    ctaText: 'Match scan speed, device type, and software compatibility to your operational environment.'
  },
  standy: {
    useCases: ['Kiosk mounts', 'Display installations', 'Device placement structures', 'Camera or biometric support frames'],
    integrations: ['Kiosks', 'Displays', 'Biometric devices', 'RFID hardware'],
    deployment: 'Designed around device size, mounting height, cable path, and environment-specific installation.',
    support: 'Includes fitment guidance, structural planning, and installation support.',
    ctaTitle: 'Plan a Better Hardware Installation',
    ctaText: 'Get the right stand structure, cable routing, and mounting layout for your hardware.'
  },
  'rommer-touch-screen': {
    useCases: ['Training rooms', 'Interactive classrooms', 'Presentation walls', 'Collaboration spaces'],
    integrations: ['Projectors', 'Laptops and PCs', 'Screen sharing workflows', 'Interactive presentation tools'],
    deployment: 'Configured around wall size, room layout, interaction area, and source device requirements.',
    support: 'Covers calibration, installation planning, usage guidance, and support after deployment.',
    ctaTitle: 'Create a Large Interactive Surface',
    ctaText: 'Turn an existing wall into a collaborative touch experience with the right configuration.'
  },
  'server-room-establishment': {
    useCases: ['Institutional data rooms', 'Campus IT infrastructure', 'Department server setups', 'Secure network operations spaces'],
    integrations: ['Server racks', 'UPS and power planning', 'Network core devices', 'Security and monitoring systems'],
    deployment: 'Includes layout planning, power and cooling design, rack setup, and infrastructure commissioning.',
    support: 'Covers documentation, deployment assistance, environment planning, and post-handover support.',
    ctaTitle: 'Build a Reliable Server Environment',
    ctaText: 'Plan server, rack, power, networking, cooling, and security together from the start.'
  }
};

export const productCatalogBySlug = productCatalog
  .map((product) => ({
    ...product,
    ...productEnhancements[product.slug],
    useCases: productEnhancements[product.slug]?.useCases || [],
    integrations: productEnhancements[product.slug]?.integrations || [],
    deployment: productEnhancements[product.slug]?.deployment || 'Deployment planning, installation support, and configuration alignment are available based on your environment.',
    support: productEnhancements[product.slug]?.support || 'Warranty-backed deployment assistance and post-installation support are available for rollout and operations.',
    ctaTitle: productEnhancements[product.slug]?.ctaTitle || `Discuss ${product.label}`,
    ctaText: productEnhancements[product.slug]?.ctaText || 'Share your use case, installation environment, and integration expectations with our team.'
  }))
  .reduce((accumulator, product) => {
  accumulator[product.slug] = product;
  return accumulator;
}, {});
